const transaction_api = "https://investment-tracker.tashu.qzz.io/api/transaction-api";
// const transaction_api = "https://investmentservices-production.up.railway.app/api/transaction-api";
// const transaction_api = "https://transaction-service-production.up.railway.app/api/users/transaction-api";
// const transaction_api = "http://localhost:8082/api/users/transaction-api";
// const transaction_api = "http://localhost:8088/api/transaction-api";


export default transaction_api;